import Vue from 'vue'
import VueRouter from 'vue-router'
import PayPage from '../views/PayPage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Pay',
    component: PayPage
  },
  {
    path: '/confirmed',
    name: 'Confirm',
    component: () => import('../views/ComfirmedPay.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
